import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { loadTranslations } from './translationLoader';
import { getDefaultLocale, getSupportedLocales, resolveLocale } from './translations';
import enGB from '../locales/en-GB/translation.json';

const defaultLocale = getDefaultLocale();

void i18n.use(initReactI18next).init({
    resources: {
        [defaultLocale]: {
            translation: enGB
        }
    },
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    supportedLngs: getSupportedLocales(),
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: false
    },
    initImmediate: false
});

export const i18nInstance = i18n;

export async function ensureI18nLocale(locale?: string | null): Promise<string> {
    const resolved = resolveLocale(locale);

    if (!i18n.hasResourceBundle(resolved, 'translation') && resolved !== defaultLocale) {
        const resources = await loadTranslations(resolved);
        if (resources) {
            i18n.addResourceBundle(resolved, 'translation', resources, true, true);
        }
    }

    if (i18n.language !== resolved) {
        await i18n.changeLanguage(resolved);
    }

    return resolved;
}

export async function ensureI18nLocaleSafe(locale?: string | null): Promise<string> {
    try {
        return await ensureI18nLocale(locale);
    } catch (error) {
        console.warn('[SKF Widget] Failed to apply locale, falling back to default locale.', error);

        try {
            if (i18n.language !== defaultLocale) {
                await i18n.changeLanguage(defaultLocale);
            }
        } catch (fallbackError) {
            console.warn('[SKF Widget] Failed to switch to default locale after locale load failure.', fallbackError);
        }

        return defaultLocale;
    }
}
